// Tiny HTML allowlist sanitizer for inline-editable text fields.
// We accept a small set of tags from execCommand-style WYSIWYG and strip
// everything else. Server re-sanitizes on render so this is defense-in-depth,
// not a security boundary.

const ALLOWED_TAGS = new Set(['B', 'STRONG', 'I', 'EM', 'A', 'BR']);
const ALLOWED_ATTRS = {
  A: new Set(['href']),
};

export function sanitizeRichText(html) {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  walk(tmp);
  return tmp.innerHTML;
}

function walk(node) {
  // Iterate over a snapshot — we mutate the tree as we go.
  const children = Array.from(node.childNodes);
  for (const child of children) {
    if (child.nodeType === Node.TEXT_NODE) continue;
    if (child.nodeType !== Node.ELEMENT_NODE) {
      child.remove();
      continue;
    }
    const tag = child.tagName;
    if (!ALLOWED_TAGS.has(tag)) {
      // Unwrap: replace this element with its descendants flattened to text.
      const text = document.createTextNode(child.textContent || '');
      child.parentNode.replaceChild(text, child);
      continue;
    }

    const allowed = ALLOWED_ATTRS[tag] || EMPTY_SET;
    Array.from(child.attributes).forEach((attr) => {
      if (!allowed.has(attr.name)) child.removeAttribute(attr.name);
    });

    if (tag === 'A') {
      const href = child.getAttribute('href') || '';
      if (/^\s*javascript:/i.test(href)) {
        child.removeAttribute('href');
      } else if (href && !/^(https?:|mailto:|tel:|\/|#)/i.test(href)) {
        // Force an http scheme on bare strings so links don't become
        // workspace-relative on the public page.
        child.setAttribute('href', 'https://' + href.replace(/^\/+/, ''));
      }
      // Always open external links in a new tab safely.
      child.setAttribute('target', '_blank');
      child.setAttribute('rel', 'noopener noreferrer');
    }

    walk(child);
  }
}

const EMPTY_SET = new Set();
